export const dataDate = () => {
    return [
        {
            title: "Kỳ trước",
            key: "previousPeriod"
        },
        {
            title: "Cùng kỳ năm ngoái",
            key: "periodLastYear"
        }
    ]
}
